import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import CommonBtn from '../../components/global/CommonBtn'
import { formatCardNumber, formatMobile } from '../../components/global/FormatString'
import { encryptionHandler, formatYearMonthExpiry, isTimeBeforeCurrentFacilityTime, isUserLoggedIn } from '../../utils/helper'
import { EMPTY_OBJECT, EVENT_TYPES, EMPTY_ARRAY, errorMessages } from '../../constants/globalConstants'
import { dynamicPaymentGateByNonce } from '../../redux/actions/booking'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { Circles } from 'react-loader-spinner'
import URL from '../../constants/urls'
import { globalKeyStore } from '../../redux/actions/globalState'
import moment from 'moment'

function ConfirmationPage({ 
        allFacility, prevFormStep, dispatch, isLoader, userDetails, selectedFacilityId, selectedCard, notify,
        cardToken
    }) {

    let linkFacility = []
    allFacility?.length > 0 ? allFacility.map((v) => {
        linkFacility.push(v?.id)
    }) : null
    let linkFacilityId = linkFacility.join(',')

    const navigate = useNavigate()
    const { facility, independant_pass_id, event_id } = useParams()
    const [localIsBookingClosed, setLocalIsBookingClosed] = useState(false)

    const { pathname } = useLocation()
    const partnername = pathname?.split('/')?.filter(v => v != '')

    const bookingData = JSON.parse(localStorage.getItem('bookingFormDetail')) ? JSON.parse(localStorage.getItem('bookingFormDetail')) : {}
    // const userDataLoc = JSON.parse(localStorage.getItem('userData'))
    const { personal_info, payment_detail, get_event_type, event_data, sessionDetails, user_consent, payment_profile_id, vehicle_details } = (bookingData) ? bookingData : EMPTY_OBJECT
    const { name, email, phone } = (personal_info) ? personal_info : EMPTY_OBJECT
    const { card_pan, card_date_expiry_month, card_date_expiry_year, card_card_security_cvx_2, zipcode } = (payment_detail) ? payment_detail : EMPTY_OBJECT
    const phone_number = formatMobile(phone)
    const card = card_pan ? formatCardNumber(card_pan) : selectedCard?.card_last_four ? formatCardNumber('000000000000' + selectedCard?.card_last_four) : ''

    useEffect(() => {
        const updatedDetails = {
            ...bookingData,
            personal_info: { name: (userDetails?.name) ? userDetails?.name : name, email: (userDetails?.email) ? userDetails?.email : email, phone: (userDetails?.phone_number) ? userDetails?.phone_number : phone },
        }
        localStorage.setItem('bookingFormDetail', JSON.stringify(updatedDetails))
    }, [isUserLoggedIn()])


    useEffect(() => {
        if (!personal_info) {
            navigate(`/${partnername?.[0]}`)
            navigate(0)
        }
    }, [])

    const onClickSubmit = () => {
        const eventTypeLoc = localStorage.getItem('selectEventType')
        let encryptCardData = ''
        
        const selLocalFacilityId = facility ? facility : JSON.parse(localStorage?.getItem('selectedFacilityId'))
        
        const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
        
        let selectEventLinkFacility = eventTypeLoc == 'pass' ? localStorage?.getItem('passData') ? JSON.parse(localStorage?.getItem('passData'))?.facility : {} : localStorage?.getItem('selectEventLinkFacility') ? JSON.parse(localStorage?.getItem('selectEventLinkFacility')).find((v) => v?.id == eventFacilityid) : {}
        console.log(selectEventLinkFacility)
        if(selectEventLinkFacility?.facility_payment_details?.facility_payment_type_id == '3'){
            let card = {
                name_on_card: name ? name : '',
                card_number: cardToken?.token || '',
                expiration_date: formatYearMonthExpiry(cardToken?.expiry),
                security_code: '',
            }
            if (cardToken?.zip_code) {
                card.zip_code = cardToken?.zip_code
            }
            encryptCardData = encryptionHandler(card)
        }else{
            const encryptedPayload = {
                name_on_card: (name) ? name : '',
                card_number: (card_pan) ? card_pan : '',
                expiration_date: `${(card_date_expiry_month) ? card_date_expiry_month : ''}${(card_date_expiry_year) ? card_date_expiry_year : ''}`,
                // Above change has a BE Dependancy, Ask Ujjwal sir
                security_code: (card_card_security_cvx_2) ? card_card_security_cvx_2 : '',
                zip_code: zipcode || ''
            }
            
            if (encryptedPayload?.expiration_date == '' && encryptedPayload?.card_number == '') {
                encryptCardData = ''
            } else if ((encryptedPayload?.expiration_date && encryptedPayload?.card_number)) {
                encryptCardData = encryptionHandler(encryptedPayload)
            }
        }

        if (selLocalFacilityId || selectedFacilityId) {
            localStorage.setItem('urlHistory', JSON.stringify(window.location.href))
            const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
            dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

            let finalPayload = {}
            let selectEventLinkFacility = eventTypeLoc == 'pass' ? localStorage?.getItem('passData') ? JSON.parse(localStorage?.getItem('passData'))?.facility : {} : localStorage?.getItem('selectEventLinkFacility') ? JSON.parse(localStorage?.getItem('selectEventLinkFacility')).find((v) => v?.id == eventFacilityid) : {}
            let facilityTimeZone = selectEventLinkFacility?.timezone ? selectEventLinkFacility?.timezone : 'America/New_York'
            let currentTime = moment().tz(facilityTimeZone).format('YYYY-MM-DD hh:mm:ss')
            let isParkingStartPassed = moment(event_data?.parking_start_time).isBefore(currentTime)
            let isBookingClosedCheck = isTimeBeforeCurrentFacilityTime(event_data?.stop_event_booking_time, facilityTimeZone)
            if ((get_event_type !== EVENT_TYPES?.EVENT && eventTypeLoc == 'pass') || !isNaN(independant_pass_id)) {
                let passEventIds
                if (event_data?.is_full_season == 0) {
                    passEventIds = JSON.parse(localStorage.getItem('userChooseEvents'))
                } else {
                    passEventIds = event_data?.all_event?.map((item) => item?.id)
                }
                console.log(encryptCardData)
                finalPayload = {
                    'multi_facility_id': linkFacilityId ? linkFacilityId : '',
                    'facility_id': eventFacilityid,
                    'name': name,
                    'phone': phone,
                    'email': email,
                    'total': sessionDetails?.data?.amount,
                    'rate_id': independant_pass_id ? independant_pass_id : get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                    'event_id': '',
                    'event_category_id': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.event_category_event?.event_category_id : event_data?.event_category_id,
                    // 'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.start_time : event_data?.all_event?.[0]?.start_time,
                    'arrival': isParkingStartPassed ? currentTime : ((get_event_type == EVENT_TYPES?.EVENT) ? event_data?.parking_start_time : event_data?.all_event?.[0]?.parking_start_time),
                    'event_type': independant_pass_id ? EVENT_TYPES?.SIMPLE : get_event_type,
                    'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
                    'reference': sessionDetails?.data?.reference,
                    'ex_month': card_date_expiry_month,
                    'ex_year': card_date_expiry_year,
                    'user_consent': (user_consent) ? user_consent : '0',
                    'nonce': encryptCardData,
                    'event_ids': passEventIds,
                    'is_booking_direct': (payment_detail) ? '0' : '1',
                    'promocode': (sessionDetails?.coupon_code) ? sessionDetails?.coupon_code : '',
                    'user_id': (isUserLoggedIn()) ? userDetails?.id : '',
                    'payment_profile_id': (payment_profile_id) ? payment_profile_id : '',
                    'pass_start_date': event_data?.start_date ? event_data?.start_date : '',
                    'pass_end_date': event_data?.end_date ? event_data?.end_date : '',
                }
            } else {
                console.log(encryptCardData)
                finalPayload = {
                    'multi_facility_id': linkFacilityId ? linkFacilityId : '',
                    'facility_id': eventFacilityid,
                    'name': name,
                    'phone': phone,
                    'email': email,
                    'total': sessionDetails?.data?.amount,
                    'rate_id': get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                    'event_id': get_event_type == EVENT_TYPES?.EVENT ? event_data?.id : '',
                    // 'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.start_time : event_data?.all_event?.[0]?.start_time,
                    'arrival': isParkingStartPassed ? currentTime : ((get_event_type == EVENT_TYPES?.EVENT) ? event_data?.parking_start_time : event_data?.all_event?.[0]?.parking_start_time),
                    'event_type': get_event_type,
                    'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
                    'user_consent': (user_consent) ? user_consent : '0',
                    'nonce': encryptCardData,
                    'payment_profile_id': (payment_profile_id) ? payment_profile_id : '',
                    'is_booking_direct': (payment_detail) ? '0' : '1',
                    'promocode': (sessionDetails?.coupon_code) ? sessionDetails?.coupon_code : '',
                    'user_id': (isUserLoggedIn()) ? userDetails?.id : '',
                    'pass_start_date': event_data?.start_date ? event_data?.start_date : '',
                    'pass_end_date': event_data?.end_date ? event_data?.end_date : '',
                }
            }

            if (vehicle_details?.vehicle_id && vehicle_details?.license_plate) {
                finalPayload.vehicle_id = vehicle_details?.vehicle_id
                finalPayload.license_plate = vehicle_details?.license_plate
            }
            if (vehicle_details?.license_plate && !vehicle_details?.vehicle_id) {
                finalPayload.license_plate = vehicle_details?.license_plate
                finalPayload.color = vehicle_details?.color
                finalPayload.make = vehicle_details?.make_id ? '' : (vehicle_details?.make == 'Others' ? vehicle_details?.make_other : vehicle_details?.make)
                finalPayload.model = vehicle_details?.model_id ? '' : ((vehicle_details?.make == 'Others' || vehicle_details?.model == 'Others') ? vehicle_details?.model_other : vehicle_details?.model)
                finalPayload.country = vehicle_details?.country
                finalPayload.state_id = vehicle_details?.state_id
                finalPayload.color_id = vehicle_details?.color_id
                finalPayload.make_id = vehicle_details?.make_id
                finalPayload.model_id = vehicle_details?.model_id
                finalPayload.vehicle_type_id = vehicle_details?.vehicle_type_id
                finalPayload.vehicle_type = vehicle_details?.vehicle_type
            }
            if (sessionDetails?.data?.discounted_amount > 0) {
                finalPayload.discount_amount = sessionDetails?.data?.discounted_amount
            }
            if (isUserLoggedIn()) {
                finalPayload.card_last_four = selectedCard?.card_last_four ? selectedCard?.card_last_four : ''
                finalPayload.expiry = selectedCard?.expiry ? selectedCard?.expiry : ''
            }
            if (sessionDetails?.data?.new_parking_amount) {
                finalPayload.new_parking_amount = sessionDetails?.data?.new_parking_amount
            }
            if (sessionDetails?.data?.new_tax_rate) {
                finalPayload.new_tax_rate = sessionDetails?.data?.new_tax_rate
            }
            if (sessionDetails?.data?.new_processing_fee) {
                finalPayload.new_processing_fee = sessionDetails?.data?.new_processing_fee
            }
            
            let selectEventTypeData= localStorage.getItem('selectEventType')

            if (isBookingClosedCheck &&  selectEventTypeData !='pass') {
                setLocalIsBookingClosed(isBookingClosedCheck)
                notify('error', errorMessages?.soldOutError)
            } else {
                dispatch(dynamicPaymentGateByNonce(finalPayload)).then((res) => {
                    if (res?.data) {
                        if (isUserLoggedIn()) {
                            let userData = JSON.parse(localStorage.getItem('userData'))
                            userData.user.phone = phone
                            userData.user.phone_number = phone
                            localStorage.setItem('userData', JSON.stringify(userData))
                        }
                        if (facility && !event_id) {
                            navigate(`/${partnername?.[0]}/${facility}/${URL?.PAYMENT_SUCCESS1}`)
                        } else {
                            navigate(`/${partnername?.[0]}/${URL?.PAYMENT_SUCCESS1}`)
                        }
                        localStorage.setItem('paymentResponse', JSON.stringify(res?.data))
                    } else {
                        if (facility && !event_id) {
                            navigate(`/${partnername?.[0]}/${facility}/${URL?.PAYMENT_FAIL2}`)
                        } else {
                            navigate(`/${partnername?.[0]}/${URL?.PAYMENT_FAIL2}`)
                        }
                        localStorage.setItem('paymentResponse', JSON.stringify(res))
                    }
                })
            }
        }
    }


    return (
        <div className="card">
            <div className="card-body">
                <div className="row">
                    <div className="col">
                        <div className="d-flex mb-3 align-items-center ">
                            <label ><b>Personal  Information</b></label>
                            <CommonBtn onClick={prevFormStep} isIconBtn className="btn btn-sm ms-3 p-0" icon={<i className="fa fa-pencil" aria-hidden="true"></i>} />
                        </div>
                        <p><b>{name}</b><br /> {email}<br /> {phone_number} </p>
                    </div>
                    {((payment_detail?.card_date_expiry_month && payment_detail?.card_date_expiry_year) || selectedCard) && <div className="col">
                        <div className="d-flex mb-3  align-items-center ">
                            <label ><b>Payment Details</b></label>
                            <CommonBtn onClick={prevFormStep} isIconBtn className="btn btn-sm ms-3 p-0" icon={<i className="fa fa-pencil" aria-hidden="true"></i>} />
                        </div>
                        <p><i className="fa fa-credit-card" aria-hidden="true"></i> {card} <span className="ms-4"><i className="fa fa-calendar" aria-hidden="true"></i>   {(card_date_expiry_month && card_date_expiry_year) ? card_date_expiry_month + '/' + card_date_expiry_year : selectedCard.expiry}</span> </p>
                    </div>}
                    {(vehicle_details?.license_plate) && <div className="col">
                        <div className="d-flex mb-3  align-items-center ">
                            <label ><b>Vehicle Details</b></label>
                        </div>
                        <p><i className="fa fa-car" aria-hidden="true"></i>   {vehicle_details?.license_plate}</p>
                    </div>}
                </div>
                <Button variant="primary" type='button' className="btn btn-primary btn" onClick={onClickSubmit} disabled={(isLoader || localIsBookingClosed) ? true : false}>
                    <div className='d-flex justify-content-center align-items-center' disabled={(isLoader) ? true : false}>
                        <span>{localIsBookingClosed ? 'Sold Out' : ((payment_detail && Number(sessionDetails?.data?.amount) > 0) ? 'Confirm & Pay' : 'Confirm & Book')}</span>  <span>
                            {isLoader ? <Circles
                                height="20"
                                width="20"
                                style={{ display: 'inline-block' }}
                                color="#ffffff"
                                ariaLabel="circles-loading"
                                visible={true}
                            /> : null}
                        </span>
                    </div>
                </Button>
                <CommonBtn className="btn btn-secondary ms-1" onClick={prevFormStep} value='Cancel' />
            </div>
        </div>
    )
}

ConfirmationPage.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    nextFormStep: PropTypes.func,
    bookingFormDetail: PropTypes.object,
    prevFormStep: PropTypes.number,
    isLoader: PropTypes.bool,
    userDetails: PropTypes.object,
    selectedFacilityId: PropTypes.string,
    selectedCard: PropTypes.string,
    paybaleAmount: PropTypes.string,
    allFacility: PropTypes.array,
    cardToken: PropTypes.object,
    iframeErrorMsg: PropTypes.string,
    tokenRef: PropTypes.object,
}

ConfirmationPage.defaulProps = {
    dispatch: noop,
    notify: noop,
    nextFormStep: noop,
    bookingFormDetail: EMPTY_OBJECT,
    prevFormStep: 0,
    isLoader: false,
    userDetails: EMPTY_OBJECT,
    selectedFacilityId: '',
    selectedCard: '',
    paybaleAmount: '',
    allFacility: EMPTY_ARRAY,
    cardToken: EMPTY_OBJECT,
    iframeErrorMsg: undefined,
    tokenRef: EMPTY_OBJECT,
}


function mapStateToProps({ globalReducers, bookingReducer, loginReducer }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        selectedEventId: globalReducers?.selectedEventId,
        bookingFormPage: globalReducers?.bookingFormPage,
        bookingFormDetail: globalReducers?.bookingFormDetail,
        isLoader: bookingReducer?.loader,
        userDetails: (Object.keys(globalReducers?.userDetails).length > 0) ? globalReducers?.userDetails : loginReducer?.data?.data?.user,
        selectedFacilityId: globalReducers?.selectedFacilityId,
        selectedCard: globalReducers?.selectedCard,
    }
}

export default connect(mapStateToProps)(ConfirmationPage)